// extracted by mini-css-extract-plugin
export default {"wrapper":"srt-stream-info_wrapper__4f+1-"};